import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/theme.service';
@Component({
  selector: 'default-layout-pos',
  templateUrl: './default-layout-pos.component.html',
  styleUrls: ['./default-layout-pos.component.scss']
})

export class DefaultLayoutPosComponent implements OnInit {
  public sidebarMinimized = false;
 
  constructor(
    private router: Router, private themeService: ThemeService) {
  }
  ngOnInit() {
   
  }

  changeTheme(theme: string) {
    this.themeService.switchTheme(theme);
}
  
}
